import React, { useEffect, useState } from "react";
import { Formik, Field, Form, useFormikContext } from "formik";
import {
  FieldWrappers,
  SubmitBtn,
  SideCancelBtn,
  Wrapper,
  ScrollableContent,
  ActionSection,
  ModalHeading,
  ModalSubHeading,
  CalendarIcon,
  RupeeIcon,
} from "../Styles/InputStyle2";
import { Select, MenuItem, Menu, TextField } from "@mui/material";
import { FaCheckCircle, FaClock, FaExclamationCircle, FaMoneyBillWave, FaUserPlus } from "react-icons/fa";
import tw from "tailwind-styled-components";
import { toast } from "react-toastify";
import * as Yup from "yup";
import { Button } from "@mui/base";
import { MdClose } from "react-icons/md";
import Images from "../../Images";
// import { Dropdown } from "react-multi-select-component";
// import Dropdown from 'react-dropdown';
// import Dropdown from "react-dropdown";
// import 'react-dropdown/style.css';



const Testing = ({ setViewTesting, SelectedData, categories }) => {
  const initialValues = {
    expiryDate: "",
    maintenanceDate: "",
    scheduleMaintenanceDate: "",
    notes: "",
    assignVendor: "",
    repetition: "",
    paymentMode: "",
    paymentDate: "",
    description: "",
    catogories: "",
    paidTo: "",
    occupation: "",
    totalDue: "",



  };
  const repetition = [
    { value: 1, label: "One Time" },
    { value: 2, label: "Monthly" },
  ];
  const occupation = [
    { value: "Professional", label: "Professional" },
    { value: "Student", label: "Student" },
  ];
  const catogories = [
    { value: 1, label: "Category 1" },
    { value: 2, label: "Category 2" },
    { value: 3, label: "Category 3" },
    { value: 4, label: "Category 4" },
    { value: 5, label: "Category 5" },
  ];

  const paymentTypes = [
    {
      value: 1,
      label: "No Dues",
      icon: <FaCheckCircle className="w-6 h-6 text-green-500" />,
    },
    {
      value: 2,
      label: "Pending Dues",
      icon: <FaClock className="w-6 h-6 text-yellow-500" />,
    },
    {
      value: 3,
      label: "Token Amount",
      icon: <FaMoneyBillWave className="w-6 h-6 text-blue-500" />,
    },
    {
      value: 4,
      label: "Excess Payment",
      icon: <FaExclamationCircle className="w-6 h-6 text-red-500" />,
    },
  ]

  const validationSchema = Yup.object({
    // occupation: Yup.string().required("Please select Occupation"),
    expiryDate: Yup.date().required("Enter Expiry Date"),
  });
  // const vendorList = [
  //   { id: "1", name: "Vendor 1" },
  //   { id: "2", name: "Vendor 2" },
  //   { id: "3", name: "Vendor 3" },
  //   { id: "4", name: "Vendor 4" },
  //   { id: "5", name: "Vendor 5" },
  // ];

  // const onClose = () => {
  //   setViewTesting(false);
  // };
  const [vendors, setVendors] = useState([
    { id: "1", name: "Vendor 1" },
    { id: "2", name: "Vendor 2" },
    { id: "3", name: "Vendor 3" },
  ]);
  const [showAddVendorForm, setShowAddVendorForm] = useState(false);
  const [vendorName, setVendorName] = useState("");
  const [vendorMobile, setVendorMobile] = useState("");

  const addNewVendor = () => {
    if (vendorName && vendorMobile) {
      setVendors([...vendors, { id: (vendors.length + 1).toString(), name: vendorName }]);
      setShowAddVendorForm(false);
      setVendorName("");
      setVendorMobile("");
    }
  };
  const paymentModes = [
    {
      value: 1,
      label: "Offline",
      icon: <img src={Images.Offline} alt="Offline" className="w-10 h-10" />,
    },
    {
      value: 2,
      label: "UPI",
      icon: <img src={Images.UPI} alt="UPI" className="w-10 h-10" />,
    },
    {
      value: 3,
      label: "Net Banking",
      icon: (
        <img src={Images.NetBanking} alt="Net Banking" className="w-10 h-10" />
      ),
    },
    {
      value: 4,
      label: "Card",
      icon: <img src={Images.Card} alt="Card" className="w-10 h-10" />,
    },
  ];
  const handleSelectedCategory = (selectedOption) => {
    if (Formik.current) {
      Formik.current.setFieldValue("category", selectedOption.value);
    }
  };

  const handleSubmit = (values) => {
    console.log("Form values:", values);
    if (!values.occupation) {
      toast.error("Please Select Occupation");
      return;
    }


    const payload = {
      maintenanceDate: values.maintenanceDate,
      expiryDate: values.expiryDate,
      scheduleMaintenanceDate: values.scheduleMaintenanceDate,
      notes: values.notes,
      assignVendor: values.assignVendor,
      repetitionType: Number(values.repetition),
      occupation: String(values.occupation),
    }
    console.log("payload data from testing", payload);
    // setFormData((prevFormData) => ({
    //     ...prevFormData,
    //     maintenanceWarranty: values,
    // }));

    // setSelectedForm("5");
    // console.log("payload data from maintenance", payload);
    // addAssetFunctionMutate(formData);
  };
  const handleBack = () => {
    // setSelectedForm("3");
    setViewTesting(false);

  }

  const FormikContextUpdater = ({ paymentType, totalDue }) => {
    const { setFieldValue, values } = useFormikContext();

    useEffect(() => {
      if (paymentType === 2) {
        setFieldValue("amountPaid", totalDue);
      }
    }, [paymentType, totalDue, setFieldValue]);

    return null;
  };

  return (
    <div className="h-full w-full flex flex-col justify-between custom-scrollbar" >
      <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={handleSubmit}>
        {({ values, setFieldValue, errors, touched }) => (
          <Container>
            <Header>
              <Title>{"Testing Modal"}</Title>
              <CloseButton onClick={() => setViewTesting(false)}>
                <MdClose size={24} />
              </CloseButton>
            </Header>
            <Form className="w-full h-full flex flex-col px-6">
              <FormikContextUpdater paymentType={values.paymentType} />

              <ScrollableContent className="max-h-[calc(100vh-140px)]">
                <Wrapper>
                  {/* <CombineInputGroup>
                    <InputGroup className="w-2/3">
                      <Label>Catogories *</Label>
                      <Select id="catogories"
                        name="catogories"
                        fullWidth
                        className="pl-2"
                        value={values.catogories}
                        onChange={(e) => setFieldValue("catogories", e.target.value, false)}>
                        {catogories.map((mode) => (
                          <MenuItem key={mode.value} value={mode.value}>
                            {mode.label}
                          </MenuItem>
                        ))}
                      </Select>
                    </InputGroup>
                    <InputGroup className="w-1/3">
                      <Label htmlFor="paymentDate">Payment Date *</Label>
                      <FieldWrappers className="relative">
                        <CalendarIcon />
                        <Field
                          type="date"
                          id="paymentDate"
                          name="paymentDate"
                          className="w-full truncate pl-6"
                          value={values.paymentDate}
                          // onChange={handleChange}
                          onChange={(e) => {
                            setFieldValue("paymentDate", e.target.value);
                          }}
                        // onBlur={handleBlur}
                        />
                      </FieldWrappers>
                    </InputGroup>
                  </CombineInputGroup> */}

                  {/* <CombineInputGroup> */}
                  <InputGroup>
                    <Label htmlFor="paymentType">Adjust Dues *</Label>
                    <PaymentModeWrapper>
                      {paymentTypes.map((option) => (
                        <PaymentModeCard
                          key={option.value}
                          // isSelected={values.paymentType === option.value}
                          onClick={() => {
                            setFieldValue("paymentType", option.value)
                            // setFieldValue("amountPaid", "");
                            if (option.value == 2) {
                              setFieldValue("amountPaid", "")
                            } else {
                              setFieldValue("amountPaid", "")
                            }
                          }}
                        className={
                          values.paymentType === option.value
                            ? "bg-blue-100 border-blue-500"
                            : "bg-gray-100"
                        }
                        >
                          {/* {option.icon} */}
                          <span className="text-sm">{option.label}</span>

                        </PaymentModeCard>
                      ))}
                    </PaymentModeWrapper>
                  </InputGroup>
                  {values.paymentType !== 1 && (
                    <InputGroup>
                      <Label htmlFor="amountPaid">Amount *</Label>
                      <FieldWrappers className="w-full">
                        <RupeeIcon />
                        <Field
                          name="amountPaid"
                          type="number"
                          placeholder={
                            values.paymentType === 2 ? `Enter Amount (Total Dues: ₹${1212})` : "Enter Amount"
                          }
                          value={values.amountPaid}
                          // value={values.paymentType == 2 ? values.amountPaid || totalDue : values.amountPaid}
                          // onFocus={() => setIsEditing(true)}
                          onChange={(e) => {
                            setFieldValue("amountPaid", e.target.value)
                          }}
                          className="w-full pl-6"
                        />
                      </FieldWrappers>
                    </InputGroup>)}
                  {/* <InputGroup>
                      <Label htmlFor="amount">Amount *</Label>
                      <FieldWrappers>
                        <RupeeIcon />
                        <Field
                          type="text"
                          name="amount"
                          id="amount"
                          className="w-full truncate pl-6"
                        />
                      </FieldWrappers>
                    </InputGroup> */}
                  {/* <InputGroup>
                      <Label htmlFor="paymentDate">Payment Date *</Label>
                      <FieldWrappers className="relative">
                        <CalendarIcon />
                        <Field
                          type="date"
                          id="paymentDate"
                          name="paymentDate"
                          className="w-full truncate pl-6"
                          value={values.paymentDate}
                          // onChange={handleChange}
                          onChange={(e) => {
                            setFieldValue("paymentDate", e.target.value);
                          }}
                        // onBlur={handleBlur}
                        />
                      </FieldWrappers>
                    </InputGroup> */}


                  {/* </CombineInputGroup> */}

                  {/* <InputGroup>
                    <Label>Repetition *</Label>
                    <Select id="repetition"
                      name="repetition"
                      fullWidth
                      className="pl-2"
                      value={values.repetition}
                      onChange={(e) => setFieldValue("repetition", e.target.value, false)}>
                      {repetition.map((mode) => (
                        <MenuItem key={mode.value} value={mode.value}>
                          {mode.label}
                        </MenuItem>
                      ))}
                    </Select>
                  </InputGroup> */}
                  {/* <InputGroup>
                    <Label>Repetition *</Label>
                    <CardWrapper>
                      {repetition.map((mode) => (
                        <SelectionCard
                          key={mode.value}
                          type="button"
                          onClick={(e) => {
                            e.preventDefault();
                            setFieldValue("repetition", mode.value, false);
                          }}
                          className={
                            values.repetition === mode.value
                              ? "bg-primary-color text-white"
                              : "bg-gray-100"
                          }
                        >
                          <span className="text-sm">{mode.label}</span>
                        </SelectionCard>
                      ))}
                    </CardWrapper>
                  </InputGroup> */}


                  <InputGroup>
                    <Label>Occupation *</Label>
                    <CardWrapper>
                      {occupation.map((mode) => (
                        <SelectionCard
                          key={mode.value}
                          type="button"
                          onClick={(e) => {
                            e.preventDefault();
                            setFieldValue("occupation", mode.value, false);
                          }}
                          className={
                            values.occupation === mode.value
                              ? "bg-[#0078BD] text-white"
                              : "bg-gray-100 text-gray-600"
                          }
                        >
                          <span className="text-sm">{mode.label}</span>
                        </SelectionCard>
                      ))}
                    </CardWrapper>
                  </InputGroup>

                  <InputGroup>
                    <Label>Payment Mode *</Label>
                    <PaymentModeWrapper>
                      {paymentModes.map((mode) => (
                        <PaymentModeCard
                          key={mode.value}
                          type="button"
                          onClick={(e) => {
                            e.preventDefault();
                            setFieldValue("paymentMode", mode.value, false);
                          }}
                          className={
                            values.paymentMode === mode.value
                              ? "bg-blue-100 border-blue-500"
                              : "bg-gray-100"
                          }
                        >
                          <span className="text-sm">{mode.label}</span>
                        </PaymentModeCard>
                      ))}
                    </PaymentModeWrapper>
                  </InputGroup>

                  {!showAddVendorForm &&
                    <CombineInputGroup>
                      <InputGroup>
                        <Label htmlFor="assignVendor">Paid by *</Label>
                        <Select
                          id="assignVendor"
                          name="assignVendor"
                          fullWidth
                          value={values.assignVendor}
                          onChange={(e) => {
                            if (e.target.value === "add_vendor") {
                              setShowAddVendorForm(true);
                            } else {
                              setFieldValue("assignVendor", e.target.value);
                              setShowAddVendorForm(false);
                            }
                          }}
                          className="pl-2"
                        >
                          <MenuItem value="add_vendor">
                            <FaUserPlus className="mr-1" /> Add Vendor
                          </MenuItem>
                          {vendors.map((vendor) => (
                            <MenuItem key={vendor.id} value={vendor.id}>
                              {vendor.name}
                            </MenuItem>
                          ))}
                        </Select>
                      </InputGroup>
                      <InputGroup>
                        <Label htmlFor="paidTo">Paid to *</Label>
                        <Select
                          id="paidTo"
                          name="paidTo"
                          fullWidth
                          value={values.paidTo}
                          onChange={(e) => {
                            if (e.target.value === "add_vendor") {
                              setShowAddVendorForm(true);
                            } else {
                              setFieldValue("paidTo", e.target.value);
                              setShowAddVendorForm(false);
                            }
                          }}
                          className="pl-2"
                        >
                          <MenuItem value="add_vendor">
                            <FaUserPlus className="mr-1" /> Add Vendor
                          </MenuItem>
                          {vendors.map((vendor) => (
                            <MenuItem key={vendor.id} value={vendor.id}>
                              {vendor.name}
                            </MenuItem>
                          ))}
                        </Select>
                      </InputGroup>
                    </CombineInputGroup>
                  }

                  {showAddVendorForm && (
                    <div className="border px-2 rounded-md">
                      <Wrapper>
                        <CombineInputGroup>
                          <InputGroup>
                            <Label htmlFor="fullName">Vendor Name *</Label>
                            <FieldWrappers>
                              <Field
                                type="text"
                                name="fullName"
                                id="fullName"
                                autoComplete="off"
                                required
                                value={vendorName}
                                onChange={(e) => setVendorName(e.target.value)}
                              />
                            </FieldWrappers>
                          </InputGroup>
                          <InputGroup>
                            <Label htmlFor="mobile">Vendor Mobile *</Label>
                            <FieldWrappers>
                              <Field
                                type="text"
                                name="mobile"
                                id="mobile"
                                autoComplete="off"
                                maxLength={10}
                                required
                                value={vendorMobile}
                                onChange={(e) => setVendorMobile(e.target.value)}
                              />
                            </FieldWrappers>
                          </InputGroup>
                        </CombineInputGroup>

                      </Wrapper>
                      <AddVendorBtn>
                        <AddVendorSubmitBtn type="button" onClick={() => setShowAddVendorForm(false)}>
                          Cancel
                        </AddVendorSubmitBtn>
                        <AddVendorSubmitBtn type="submit" color="primary" onClick={addNewVendor}>
                          {"Submit"}
                        </AddVendorSubmitBtn>
                      </AddVendorBtn>
                    </div>
                  )}

                  {!showAddVendorForm &&
                    <InputGroup>
                      <Label htmlFor="description">Description *</Label>

                      <Field
                        as={Textarea}
                        id="description"
                        name="description"
                        rows={5}
                        placeholder="Enter Description"
                      />

                    </InputGroup>
                  }

                </Wrapper>
              </ScrollableContent>
              <ActionSection>
                <SideCancelBtn type="button">
                  Back
                </SideCancelBtn>
                <SubmitBtn type="submit" onClick={()=>{console.log("form submitted")}}>
                  Submit
                </SubmitBtn>
              </ActionSection>
            </Form>
          </Container>
        )}
      </Formik>
    </div>
  );
};
// const PaymentModeWrapper = tw.div`grid grid-cols-4 gap-2 my-1.5`;

const Container = tw.div`bg-white w-full h-full flex flex-col`;
const Header = tw.div`flex items-center justify-between bg-primary-color py-4 px-4`;
const Title = tw.h1`text-white text-lg md:text-xl font-medium`;
const CloseButton = tw.button`text-white`;
const Vendor = tw.button`text-blue-500 text-sm flex hover:underline`
const CombineInputGroup = tw.div`w-full flex md:flex-row flex-col space-x-4 items-end`;
const Textarea = tw.textarea`min-h-10 max-h-40 border border-gray-300 rounded pl-2 py-2 focus:ring-1 focus:ring-sky-600  focus:border-sky-600 focus:outline-none duration-200 w-full h-20 resize-y break-words overflow-hidden`;
const ErrorText = tw.div`text-red-500 text-sm ml-0.5`;
const InputGroup = tw.div`w-full flex flex-col mt-2 md:mt-0`;
const Label = tw.label`text-sm text-gray-500 font-normal mb-1.5`;
const Heading = tw.h2`text-sm font-medium text-gray-800`;
const AddVendorBtn = tw.div`bg-white flex justify-end py-2 px-2 gap-2`;
const AddVendorSubmitBtn = tw.button`
text-xs  w-12   md:w-14 h-6 grid place-items-center disabled:opacity-50 disabled:cursor-not-allowed md:text-xs bg-primary-color hover:bg-hover-color text-white rounded-md shadow-md`;
const CardWrapper = tw.div`flex flex-wrap gap-2 my-1.5`;
const SelectionCard = tw.button`flex flex-col items-center justify-center p-2 px-8 border rounded-lg shadow-sm cursor-pointer`;
const PaymentModeCard = tw.button`flex flex-col items-center justify-center p-2 border rounded-lg shadow-sm cursor-pointer`;

const OptionCard = tw.button`flex flex-col items-center justify-center p-2 border rounded-lg shadow-sm cursor-pointer`;
const PaymentModeWrapper = tw.div`grid grid-cols-4 gap-2 my-1.5`;
// const PaymentModeCard = tw.button`flex flex-col items-center justify-center p-2 border rounded-lg shadow-sm cursor-pointer bg-gray-100`;



export default Testing;